module.exports = __webpack_public_path__ + "static/media/searchicon.3bf4485e.svg";